<div class="row">
  <h4 class="column twelve pad-top-20 font-weight-bold">
    Where should we ship your Automatic&trade; plug-in adapter?
  </h4>
  @if (loaded) {
    <div class="column twelve" [formGroup]="kydForm">
      @for (risk of risks; track risk) {
        <div>
          <app-kyd-ship-to
            [kydForm]="kydForm"
            [risk]="risk"
            [shipTos]="shipTos"
            (addressChange)="addressChange($event)"
          >
          </app-kyd-ship-to>
        </div>
      }
    </div>
  }
</div>
